import { List } from "@mui/material";
import UbicacionCard from "../UbicacionCard";

const Ubicaciones = ({ubicaciones, onAsistencia, onCheck, hayCancelables}) => {
  return <List>
    {ubicaciones.map(ubicacion => <UbicacionCard {...ubicacion} onAsistencia={!!onAsistencia ? () => onAsistencia(ubicacion) : null} onCheck={!!onCheck ? () => onCheck(ubicacion) : null} hayCancelables={hayCancelables} />)}
  </List>
}

export default Ubicaciones;